const translation = {
  tags: {
    utilities: 'ユーティリティ',
    weather: '天気',
    education: '教育',
    design: 'デザイン',
    videos: 'ビデオ',
    search: '検索',
    finance: '金融',
    productivity: '生産性',
    image: '画像',
    entertainment: 'エンターテインメント',
    medical: '医療',
    social: '社会',
    news: 'ニュース',
    other: '他',
    agent: 'エージェント',
    business: 'ビジネス',
    travel: '旅行',
  },
  searchTags: '検索タグ',
  allTags: 'すべてのタグ',
}

export default translation
